import { vsLookupManagementServiceProviderName } from "./../lookupManagement";
import { simpleLookupManagementConfig } from "../../../records/lookup/utils/simpleLookupManagementConfig";

export const vsObjectName = "gamingContractTypeOfAgreement";

const url = "api/contract/gamingContract/typeOfAgreement";

export const TypeOfAgreementConfig = simpleLookupManagementConfig({
  lookupEditPermission: "contractLookupModify",
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
  nameSingular: "Type Of Agreement",
  namePlural: "Types Of Agreement",
  objectName: vsObjectName,
  url,
});
